import { cn } from "@common/lib/utils"
import { RefreshCw } from "lucide-react"

const ERP_AVATAR = cn(
  "flex size-5 shrink-0 items-center justify-center rounded-full",
  "bg-muted text-muted-foreground",
)

export function ErpAvatar(): React.ReactElement {
  return (
    <span
      role="img"
      aria-label="Synced from ERP"
      title="Synced from ERP"
      className={ERP_AVATAR}
    >
      <RefreshCw className="size-3" />
    </span>
  )
}
